<template>
  <div class="goods-page-content">
    <div class="container_box" style="padding: 10px 0;">
      <classify v-if="false"></classify>
      <div v-if="newCustomerPriceFlag
        && newCustomerPriceFlag !== ''
        && productList.length > 0
        && productList[0].inventoryList
        && productList[0].inventoryList.length > 0
        && productList[0].inventoryList[0].newCustomerPriceFlag !== '1'" class="errorTip">
        <p class="tipText">您不符合活动条件，不能参与该活动哦！</p>
        <span class="back-home">
          <router-link to="/">返回首页</router-link>
        </span>
      </div>
      <div v-else>
        <!-- 排序条件 -->
        <div class="screen-key-content">
          <div class="screen-container">
            <div class="screen-key" v-for="(item, index) of screenList" :key="'screen-key' + index">
              <p @click="selectScreen(item, index)" :class="{ orderAct: screenType == index }">
                {{ item
                }}{{ screenType == index && screenType > 0 ? sortTypeText : "" }}
              </p>
            </div>

            <div v-if="false" class="pricerange">
              价格区间:
              <div class="price">
                <input type="text" class="price-range start" id="minPrice" @focus="showRangeStatus = true"
                  v-model="minPrice" @blur="inputBlur" onkeyup="this.value = this.value.replace(/\D/g, '')"
                  onchange="this.value = this.value.trim()" maxlength="4" />
                -
                <input type="text" class="price-range" id="maxPrice" @blur="inputBlur" v-model="maxPrice"
                  @keyup.enter="priceSearch" @focus="showRangeStatus = true"
                  onkeyup="this.value = this.value.replace(/\D/g, '')" onchange="this.value = this.value.trim()"
                  maxlength="4" />
              </div>
              <div class="range" v-show="showRangeStatus">
                <a href="javascript:;" @click="clearPriceNum" class="ssClear" id="ssClear">清空</a>
                <a href="javascript:;" @click="priceSearch" class="ssConfirm" id="ssConfirm">确认</a>
              </div>
            </div>
            <div class="hasStocket">
              <el-switch v-model="hasStocket" @change="getProductListData" active-text="只显示有货">
              </el-switch>
            </div>
            <div class="selected-stock">
              <el-select @change="selectedStock" clearable popper-class="stock-select" size="mini" v-model="companyId" placeholder="仓位筛选">
                <el-option v-for="item in stockOptions" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div v-if="false" class="goods-tips">
            <div class="goods-show-num">
              <p style="padding-right: 15px">
                共<span class="goods-aount">{{ totalCount }}</span>个商品，每页展示<span> {{ pageSize }} </span>个
              </p>
            </div>
            <div v-if="false" class="switchBtnBox">
              <div @click="changeProductListType" class="switchBtn">
                <div :style="productShowType == '1' ? 'left:0px' : 'left:19px'" class="btn">
                  {{ productShowType == '1' ? "大图" : "列表" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end 排序条件 -->
        <div class="proTable">
          <div v-if="productList.length === 0 && !productLoading" class="dataNone container_box">
            <div class="dataImg productNoneImg"></div>
          </div>
          <div v-else v-loading="productLoading" class="cartMain">
            <ul v-if="productShowType == '1'" class="goods-list-header">
              <li class="activity">
                <p></p>
              </li>
              <li class="name">商品名称</li>
              <li class="format">规格</li>
              <li class="unit">单位</li>
              <li class="manufacturer">生产厂家</li>
              <li class="validity">有效期</li>
              <li class="package">中/大包装</li>
              <li class="price">单价</li>
              <!-- <li class="discountPrice">折扣价</li> -->
              <li class="discountPrice">预计到货</li>
              <li class="inventory">库存</li>
              <li class="amount">数量</li>
              <li class="operation"></li>
            </ul>
            <div class="productListBox">
              <table-pro-list v-if="productShowType == '1'" :productList="productList">
              </table-pro-list>
              <img-pro-list v-else :productList="productList"> </img-pro-list>
            </div>
          </div>
        </div>
        <div class="pagination-bottom">
          <el-pagination background v-if="totalCount > 0" :hide-on-single-page="true"
            layout="prev, pager, next, total, jumper" :current-page="pageNo" @current-change="currentChange"
            @size-change="handleSizeChange" :page-size="pageSize" :total="totalCount">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TableProList from "@/components/product/TableProList.vue";
import { getAction } from "../api/manage";
import ImgProList from "../components/product/ImgProList.vue";
import Classify from "../components/product/Classify.vue";
import merge from 'webpack-merge'
import Vue from 'vue';
export default {
  components: { TableProList, ImgProList, Classify },
  props: ["searchName"],
  name: "ProductList",
  data() {
    return {
      pageNo: 1,
      pages: 1,
      pageSize: 20,
      totalCount: 1,
      searchVal: "",
      collectFlag: "",
      productShowType: '1',
      productLoading: true,
      productList: [],
      manufacturer: "",
      hasStocket: false, // 只展示有库存的
      maxPrice: "",
      minPrice: "",
      showRangeStatus: false,
      screenList: ["默认排序", "销量", "价格", "人气"],
      stockOptions: [
      ],
      companyId: '',
      screenType: 0, // 4:销量 2:价格 3:人气
      sortType: 1, // 1:升序 2:降序
      sortTypeText: "由低到高", // 排序提示
      productCategory: "", // 产品分类
      nearDateFlag: "", // 产品分类
      productLabelList: "", // 产品标签数据
      newCustomerPriceFlag: "", // 搜索指定新人特价产品
      discountTicketId: "", // 搜索指定优惠券的产品数据
    };
  },
  created() {
    let productShowType = Vue.ls.get('productShowType');
    if (productShowType && productShowType !== '') {
      this.productShowType = productShowType
    } else {
      this.productShowType = '1'
    }
    // 检测平台设置的默认产品列表展示模式
    let searchVal = this.$route.query.searchVal;
    let companyId = this.$route.query.companyId;
    let manufacturer = this.$route.query.manufacturer;
    let productCategory = this.$route.query.productCategory;
    let nearDateFlag = this.$route.query.nearDateFlag;
    let collectFlag = this.$route.query.collectFlag;
    let productLabelList = this.$route.query.productLabelList;
    let newCustomerPriceFlag = this.$route.query.newCustomerPriceFlag;
    let discountTicketId = this.$route.query.discountTicketId;
    this.manufacturer = manufacturer;
    this.productCategory = productCategory;
    this.nearDateFlag = nearDateFlag;
    this.newCustomerPriceFlag = newCustomerPriceFlag;
    this.discountTicketId = discountTicketId;
    this.productLabelList = productLabelList;
    this.searchVal = searchVal;
    this.companyId = companyId;
    this.collectFlag = collectFlag;
    this.getProductListData();
    this.getStockList();
  },
  methods: {
    async getStockList() {
      let url = "customer/customer/getMyCompany";
      let res = await getAction(url,{});
      if(res.code === 200 && res.success && res.result) {
        this.stockOptions = res.result;
      }
      console.log("返回的商品仓库列表数据为", res)
    },
    changeProductListType() {
      let productShowType = this.productShowType;
      if (productShowType == '1') {
        this.productShowType = '2'
      } else {
        this.productShowType = '1'
      }
      // 记录用户选择的列表展示模式
      this.$ls.set('productShowType', this.productShowType)
    },
    inputBlur() {
      let minPrice = this.minPrice;
      let maxPrice = this.maxPrice;
      if (minPrice == '' && maxPrice == '') {
        this.showRangeStatus = false
      }
    },
    // 价格区间查询
    priceSearch() {
      this.showRangeStatus = false;
      this.getProductListData();
    },
    // 清空价格区间筛选
    clearPriceNum() {
      this.minPrice = "";
      this.maxPrice = "";
      this.showRangeStatus = false;
      this.getProductListData();
    },
    // 点击返回顶部方法
    backTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "auto",
      });
    },
    // 筛选指定仓位的商品为
    selectedStock(value) {
      console.log("选中的仓库信息为", value)
      this.companyId = value;
      this.getProductListData();
    },
    // 选择商品筛选排序条件
    selectScreen(item, index) {
      let sortType = this.sortType;
      let screenType = this.screenType;
      let companyId = this.companyId;
      // 人气默认由高到低
      if (screenType == index && index > 0) {
        if (sortType == 1) {
          this.sortTypeText = "由高到低";
          this.sortType = 2;
        } else {
          this.sortTypeText = "由低到高";
          this.sortType = 1;
        }
      } else if (screenType !== index && index > 0) {
        // 初始人气、销量默认从高到低
        if (index == 3 || index == 1) {
          this.sortType = 2;
          this.sortTypeText = "由高到低";
        } else {
          this.sortType = 1;
          this.sortTypeText = "由低到高";
        }
      } else {
        this.sortType = 1;
        this.sortTypeText = "";
      }
      this.companyId = companyId;
      this.screenType = index;
      this.getProductListData();
    },
    // 获取产品列表数据
    getProductListData() {
      this.backTop();
      let _this = this;
      this.productLoading = true;
      let productCategory = this.productCategory;
      let productLabelList = this.productLabelList;
      let newCustomerPriceFlag = this.newCustomerPriceFlag;
      let discountTicketId = this.discountTicketId;
      let nearDateFlag = this.nearDateFlag;
      let manufacturer = this.manufacturer;
      let searchVal = this.searchVal;
      let collectFlag = this.collectFlag;
      let pageNo = this.pageNo;
      let pageSize = this.pageSize;
      let data = {
        searchVal: searchVal,
        pageNo: pageNo,
        pageSize: pageSize,
      };
      if (newCustomerPriceFlag && newCustomerPriceFlag !== "" && (!searchVal || searchVal == "")) {
        data.newCustomerPriceFlag = newCustomerPriceFlag;
      }
      if (discountTicketId && discountTicketId !== "" && (!searchVal || searchVal == "")) {
        data.discountTicketId = discountTicketId;
      }
      if (productCategory && productCategory !== "") {
        data.productCategory = productCategory;
      }
      if (nearDateFlag && nearDateFlag !== "" && (!searchVal || searchVal == "")) {
        data.nearDateFlag = nearDateFlag;
      }
      if (manufacturer && manufacturer !== "") {
        data.manufacturer = manufacturer;
      }
      if (productLabelList && productLabelList !== "") {
        data.productLabelList = productLabelList;
      }
      if (collectFlag && collectFlag !== "") {
        data.collectFlag = collectFlag;
      }
      // 判断筛选条件
      // 1. 判断是否只显示有库存的产品数据
      let hasStocket = this.hasStocket;
      if (hasStocket) {
        data["productScreenBO.isInventory"] = 1;
      } else {
        data["productScreenBO.isInventory"] = 0;
      }
      // 2.判断价格区间
      let maxPrice = this.maxPrice;
      let minPrice = this.minPrice;
      if (maxPrice !== "") {
        data["productScreenBO.maxPrice"] = maxPrice;
      }
      if (minPrice !== "") {
        data["productScreenBO.minPrice"] = minPrice;
      }
      // 判断筛选条件和升降序
      let screenType = this.screenType;
      let sortType = this.sortType;
      let companyId = this.companyId;
      // screenType: 4: 销量 2:价格 3.人气
      // sortType: 1: 升序  2.降序
      if (screenType !== "" && screenType > 0) {
        if (screenType == 1) {
          data["productScreenBO.screenType"] = 4;
        } else {
          data["productScreenBO.screenType"] = screenType;
        }
        data["productScreenBO.sortType"] = sortType;
      }
      
      if(companyId && companyId !== '') {
        data.companyId = companyId
      }
      let url = "/product/getlistE";
      console.log("请求列表的数据为+++++++", data)
      getAction(url, data, true)
        .then((res) => {
          _this.productLoading = false;
          if (res.code === 200 && res.success) {
            let pageData = res.result.pageData;
            _this.productList = pageData.records;
            _this.pageNo = pageData.current;
            _this.pages = pageData.pages;
            _this.totalCount = pageData.total;
            let productList = this.productList;
            if (newCustomerPriceFlag
              && newCustomerPriceFlag !== ''
              && productList.length > 0
              && productList[0].inventoryList
              && productList[0].inventoryList.length > 0
              && productList[0].inventoryList[0].newCustomerPriceFlag !== '1') {
              // 5秒后跳转首页
              setTimeout(function () {
                _this.$router.push('/')
              }, 5000)
            }
          } else {
            _this.productList = [];
            _this.productLoading = false;
          }
        })
        .catch((error) => {
          _this.productList = [];
          _this.productLoading = false;
        });
    },
    // 搜索产品的操作
    searchProduct(searchName, labelFlag) {
      this.clearSearchUrlData();
      this.searchVal = searchName;
      this.pageNo = 1;
      let productCategory = this.$route.query.productCategory;
      if (productCategory && productCategory !== '') {
        delete this.$route.query.productCategory
      }
      let productLabelList = this.$route.query.productLabelList;
      if (!labelFlag && productLabelList && productLabelList !== '') {
        delete this.$route.query.productLabelList
      }
      console.log("当前搜索的数据为this.$route.query", this.$route.query)
      console.log("当前搜索的数据为", searchName)
      console.log("this.$router", this.$router)
      this.$router.push({
        query: merge(this.$route.query, { 'searchVal': searchName, t: Date.now() })
      })
      // todo 这里解开会导致搜索会请求两次
      // this.getProductListData();
    },
    // 搜索收藏夹产品的操作
    searchCollectProduct(searchName) {
      this.clearSearchUrlData();
      this.searchVal = searchName;
      this.collectFlag = 1;
      this.pageNo = 1;
      this.getProductListData();
    },
    searchProductCategory(productCategory) {
      this.clearSearchUrlData();
      this.productCategory = productCategory;
      this.getProductListData();
    },
    clearSearchUrlData() {
      this.productCategory = "";
      this.productLabelList = "";
      this.manufacturer = "";
      this.collectFlag = "";
      this.searchVal = "";
      this.newCustomerPriceFlag = "";
      this.discountTicketId = "";
      this.pageNo = 1;
    },
    currentChange(val) {
      this.pageNo = val;
      this.getProductListData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getProductListData();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/product/product";
</style>